import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { getRequestMileageConfigurationUseCase } from '../business-logic/use-cases/GetRequestMileageConfiguration'
import { expenseRepository } from '../data-access/repositories/ExpenseRepository'

const base = ['expense']

export const expenseQueryConfig = {
  drafts: () => ({
    queryKey: buildQueryKey([...base, 'drafts']),
    queryFn: () => expenseRepository.getDrafts(),
  }),
  requestFormData: () => ({
    queryKey: buildQueryKey([...base, 'request-form-data']),
  }),
  requestMileageConfiguration: () => ({
    queryKey: buildQueryKey([...base, 'request-mileage-configuration']),
    queryFn: () => getRequestMileageConfigurationUseCase.execute(),
  }),
}
